var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Import datastore helper functions if needed from '@freelancer/datastore/core'
// import { toNumber } from '@freelancer/datastore/core';
import { transformLocation } from '@freelancer/datastore/project-view-users';
import { _transformProject } from '@freelancer/datastore/projects';
import { transformSkill } from '@freelancer/datastore/skills';
// Transforms what the backend returns into a format your components can consume
// Should only be called in this collection's reducer
export function transformProjectViewProjects(project, allSelectedBids) {
    return __assign({}, _transformProject(project, allSelectedBids), { 
        // Extra things for freelancer pvp
        attachments: (project.attachments || []).map(function (attachment) {
            return transformProjectAttachment(attachment);
        }), canPostReview: project.can_post_review || {}, description: project.description, location: project.location
            ? transformLocation(project.location)
            : undefined, qualifications: project.qualifications
            ? project.qualifications.map(transformQualification)
            : [], jobs: (project.jobs || []).map(transformSkill), ndaDetails: project.nda_details
            ? transformNDADetails(project.nda_details)
            : { signatures: [] } });
}
// exactly the same as transformProjectViewProjects just with less required fields
export function transformProjectViewProjectsPush(projectIn) {
    // add stuff we might be missing from API
    var project = __assign({}, projectIn, { bid_stats: { bid_count: 0 }, time_submitted: projectIn.time_submitted
            ? projectIn.time_submitted * 1000
            : Date.now() });
    return transformProjectViewProjects(project, []);
}
function transformProjectAttachment(attachment) {
    return {
        id: attachment.id,
        filename: attachment.filename,
        timeSubmitted: (attachment.time_submitted || 0) * 1000,
        url: "https://" + attachment.url,
        accessHash: attachment.access_hash,
        contentType: attachment.content_type,
    };
}
export function transformQualification(qualification) {
    return {
        id: qualification.id,
        description: qualification.description,
        iconName: qualification.icon_name,
        iconUrl: qualification.icon_url,
        level: qualification.level,
        name: qualification.name,
        scorePercentage: qualification.score_percentage,
        type: qualification.type,
        userPercentile: qualification.user_percentile,
    };
}
function transformNDADetails(ndaDetails) {
    return {
        hiddenDescription: ndaDetails.hidden_description,
        signatures: ndaDetails.signatures
            ? ndaDetails.signatures.map(transformNDASignatures)
            : [],
    };
}
function transformNDASignatures(signatures) {
    return {
        timeSigned: signatures.time_signed
            ? signatures.time_signed * 1000
            : undefined,
        projectId: signatures.project_id,
        userId: signatures.user_id,
    };
}
